import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { createRegion, resetFilters } from "../redux/regionsSagas";
import { MainModal } from "../../../../components/modal/MainModal";
import { useError } from "../hooks/useError";
import { Filters } from "./Filters";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import { ErrorList } from "../../../../components/ErrorList";

export const Add = ({ isOpen, onClose, locations }) => {
  const dispatch = useDispatch();

  const [name, setName] = useState("");
  const [selectedLocations, setSelectedLocations] = useState([]);

  const close = () => {
    dispatch(resetFilters());
    onClose();
  };

  const { errors, status } = useError(close);

  const save = () => {
    dispatch(createRegion({ name, locations: selectedLocations }));
  };

  const primaryButtonDisabled = !(name && name.trim() && status !== "pending");

  return (
    <>
      <MainModal
        isOpen={isOpen}
        onClose={close}
        parentSelector=".regions"
        headerText="Add Region"
        headerCloseHandler={close}
        bodyClassName="main-popup-body"
        primaryButtonText="Save"
        primaryButtonDisabled={primaryButtonDisabled}
        primaryBtnHandler={save}
        secondaryBtnText="Cancel"
        secondaryBtnHandler={close}
        height={300}
        width={900}
      >
        <>
          <Filters
            name={name}
            onInputChange={setName}
            locations={locations}
            selectedLocations={selectedLocations}
            onSelectChange={setSelectedLocations}
          />
        </>
        {status === "pending" && <LoadingAnimation uiLoader />}
        <ErrorList errors={errors} />
      </MainModal>
    </>
  );
};
